import { BehaviorSubject, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { TokenFormModel } from '../../views/pages/auth/models/tokenform.model';
import { ErrorFormModel } from '../../views/pages/auth/models/errorform.model';
import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NotificationService } from '../notification.service';
import DevExpress from 'devextreme';
import LocalStore = DevExpress.data.LocalStore;
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class AuthService {

  tokenForm: TokenFormModel = new TokenFormModel('', new Date(), 0, '', '', '',
    '', '', '', '', '', 0, '');
  errorForm: ErrorFormModel = new ErrorFormModel('', '');
  loginSuccess = new Subject<TokenFormModel>();
  forgotPasswordSuccess = new BehaviorSubject<boolean | undefined>(undefined);
  loginError = new Subject<ErrorFormModel>();
  loginStatusChanged = new Subject<boolean>();
  loggedIn = false;

  constructor(private httpClient: HttpClient,
    private title: Title,
    private oneSignal: NotificationService) {
  }

  propagateSuccess(val: TokenFormModel) {
    this.tokenForm = val;
    this.loggedIn = true;
    localStorage.setItem('token_form', JSON.stringify(this.tokenForm));
    localStorage.setItem('hotelId', val.app_hotel_id.toString());
    this.loginSuccess.next(this.tokenForm);
    this.loginStatusChanged.next(true);
  }

  isLogged(): boolean {
    const tform: TokenFormModel = JSON.parse(localStorage.getItem('token_form'));
    if (tform) {
      this.tokenForm = tform;
      this.loggedIn = true;
    }
    return this.loggedIn;
  }

  logOff() {
    this.tokenForm = new TokenFormModel('', new Date(), 0, '', '', '',
      '', '', '', '', '', 0, '');
    this.loggedIn = false;
    this.loginStatusChanged.next(false);
    this.title.setTitle('Guestny Panel');
    localStorage.removeItem('token_form');

    const oneSignalId = localStorage.getItem('oneSignalId');
    console.log(oneSignalId);
    if (oneSignalId) {
      this.httpClient.post(environment.baseURL + '/v2' + '/api/notifications_logout_users/' + oneSignalId,
        {
          observe: 'body',
          responseType: 'json'
        });
      localStorage.removeItem('oneSignalId');
    }


  }

  propagateError(val: ErrorFormModel) {
    this.errorForm = val;
    this.loggedIn = false;
    this.loginStatusChanged.next(false);
    this.loginError.next(this.errorForm);
  }

  signinUser(email: string, password: string) {
    this.httpClient.post(environment.baseURL + '/v2' + '/login',
      {
        username: email,
        password
      })
      .subscribe(
        (data: TokenFormModel) => {
          this.propagateSuccess(data);
          this.oneSignal.oneSignalLogin(data.token_val);
        },
        (error) => {
          console.log(error);
          this.propagateError(error.error);
        }
      );
  }

  forgotPassword(email: string) {
    this.httpClient.post(environment.baseURL + '/v2' + '/forgot_password', { email }).subscribe(
      () => {
        this.forgotPasswordSuccess.next(true);
      },
      (err) => {
        console.log(err);
        this.forgotPasswordSuccess.next(false);
      }
    );
  }

}
